import { useEffect, useState } from 'react';
import { api, ApiError } from '../api';
import type { Shard } from '../api';
import { Gump } from '../components/Gump';
import { numero, t } from '../i18n/idioma';
import { useSession } from '../state/SessionContext';

const STATUS_CHAVE: Record<Shard['status'], string> = {
  aberto: 'shard.aberto',
  cheio: 'shard.lotado',
  manutencao: 'shard.manutencao'
};

export function ShardScreen() {
  const { account, chooseShard, signOut } = useSession();
  const [shards, setShards] = useState<readonly Shard[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    api.listShards()
      .then(list => { if (live) setShards(list); })
      .catch((err: unknown) => {
        if (live) setError(err instanceof ApiError ? err.message : t('shard.naoListou'));
      });
    return () => { live = false; };
  }, []);

  return (
    <main className="screen">
      <div className="screen__inner">
        <div className="brand">
          <h1>{t('shard.titulo')}</h1>
          <p>{t('shard.explicacao')}</p>
        </div>

        <Gump title={account ? t('shard.conta', { nome: account.displayName }) : t('shard.shards')}>
          {error && <p className="notice" role="alert">{error}</p>}

          {!shards && !error && <p className="empty">{t('shard.consultando')}</p>}

          {shards && (
            <div className="picklist">
              {shards.map(shard => {
                const closed = shard.status !== 'aberto';
                const load = Math.round((shard.online / shard.capacity) * 100);
                return (
                  <button
                    key={shard.id}
                    type="button"
                    className="pick"
                    disabled={closed}
                    onClick={() => chooseShard(shard)}
                  >
                    <span className="pick__name">{shard.name}</span>
                    <span className={`pick__tag pick__tag--${shard.status === 'aberto' ? 'open' : 'full'}`}>
                      {t(STATUS_CHAVE[shard.status])}
                    </span>
                    <span className="pick__meta">
                      {shard.region} · {numero(shard.online)} {t('shard.de')}{' '}
                      {numero(shard.capacity)} · {shard.ping} ms
                    </span>
                    <span className="bar-mini"><i style={{ width: `${load}%` }} /></span>
                  </button>
                );
              })}
            </div>
          )}
        </Gump>

        <div className="row row--end">
          <button type="button" className="btn btn--ghost" onClick={() => void signOut()}>
            {t('auth.sairDaConta')}
          </button>
        </div>
      </div>
    </main>
  );
}
